module.exports = __webpack_public_path__ + "static/img/ssdj.144a349f.svg";